import {int} from "@goodgamestudios/math-utilities";
import {instanceOfClass} from "@goodgamestudios/createjs-utilities";
import { getLogger } from "@goodgamestudios/logger";


export class CacheHelper {
    private static _showCacheMarkers:boolean = false;
    public static markerName : string = "CacheMarker";
    public static markerColor : string = "#ff0000";
    public static markerAlpha : number = 0.85;
    private static logger = getLogger("CacheHelper");

    /**
     * When trying to cache a huuuge image, it could lead to some runtime errors, because the required size for
     * the cached image would not fit into the memory.
     * Because of that, the maxWidth and maxHeight can be set as a security measurement.
     * 5000 is just a suggestion, feel free to use images with higher dimensions, but make sure to test it
     */
    public static cacheGraphic( container:createjs.Container, maxWidth:number = 5000, maxHeight:number = 5000 ):void {
        container.uncache();
        let bounds:Rectangle = container.getBounds();
        if( bounds.width > 0 && bounds.height > 0 && bounds.width <= maxWidth && bounds.height <= maxHeight ) {
            container.cacheCanvas ? container.updateCache() : container.cache(bounds.x, bounds.y, bounds.width, bounds.height);
        } else {
            CacheHelper.logger.warn("Could not cache Graphic " + container.name + ", because size is "+bounds.width+"x"+bounds.height);
        }
    }

    /// Debug function: Showing what's cached ///
    public static showWhatsCached( stage:createjs.Stage = null ):void {
        let container : createjs.Container = stage ? stage : (window as any).gamestage;
        for( let i : number = 0; i < container.numChildren; i++ ) {
            if( !CacheHelper._showCacheMarkers ) {
                CacheHelper.showWhatsCachedOfContainer(container.getChildAt(i) as createjs.Container);
            } else {
                CacheHelper.hideWhatsCachedOnContainer(container.getChildAt(i) as createjs.Container);
            }
        }
        CacheHelper._showCacheMarkers = !CacheHelper._showCacheMarkers;
    }

    private static showWhatsCachedOfContainer( cont:createjs.Container ) :void {
        for( let i : number = 0; i < cont.numChildren; i++ ) {
            let kid:createjs.DisplayObject = cont.getChildAt(i);

            // if it's cached, add a marker on top
            if( kid.name != CacheHelper.markerName && kid.cacheCanvas ) {
                let shape : createjs.Shape = new createjs.Shape();
                let bounds : createjs.Rectangle = kid.getBounds();
                shape.graphics.beginFill(CacheHelper.markerColor, CacheHelper.markerAlpha);
                shape.graphics.drawCircle( bounds.right - (bounds.left/2), bounds.top - (bounds.bottom/2), 25);
                shape.graphics.endFill();
                shape.name = CacheHelper.markerName;
                (kid as createjs.Container).addChild(shape);
                kid.updateCache();
            }

            if( kid instanceof createjs.Container && (kid as createjs.Container).numChildren > 0 ) {
                CacheHelper.showWhatsCachedOfContainer( kid );
            }
        }
    }

    private static hideWhatsCachedOnContainer( cont:createjs.Container ):void {
        for( let i : number = 0; i < cont.numChildren; i++ ) {
            let kid:createjs.DisplayObject = cont.getChildAt(i);

            // if it's cached, add a marker on top
            if( kid.name == CacheHelper.markerName ) {
                let parent:createjs.Container = kid.parent;
                parent.removeChild( kid );
                if( parent.cacheCanvas ) {
                    parent.updateCache();
                }
                i--;
            }
            else if( kid instanceof createjs.Container && (kid as createjs.Container).numChildren > 0 ) {
                CacheHelper.hideWhatsCachedOnContainer( kid );
            }
        }
    }

}
